/**
 * @module app.track.gpx
 */
import appTrackService from '../track/service.js';

class Controller {
  /**
   * @param {angularGettext.Catalog} gettextCatalog
   * @param {app.track.service} appTrackService
   * @ngInject
   */
  constructor(gettextCatalog, appTrackService) {

    /**
     * @export
     */
    this.appTrackService = appTrackService;

    /**
     * @type {?number|undefined}
     * @export
     */
    this.gpsPoints;

  }

  $onInit() {
    console.assert(this.appTrackService.selectedTrack);
    this.gpsPoints = this.appTrackService.selectedTrack.properties.gpspoints;
  }

  /**
   * @export
   * @param {?number|undefined} gpsPoints
   */
  setGpsPoints(gpsPoints) {
    this.gpsPoints = gpsPoints;
  }

}

/**
 * @const {!angular.Component}
 */
const component = {
  controller: Controller,
  templateUrl: 'js/app/track/gpx/partial.html'
};

export default angular.module('appTracksGpxComponent', [
  appTrackService.name
]).component('appTracksGpx', component);
